/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Close_NavigationInputs */

const en_sidebar_close_navigation = /** @type {(inputs: Sidebar_Close_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close navigation`)
};

const es_sidebar_close_navigation = /** @type {(inputs: Sidebar_Close_NavigationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar navegacion`)
};

/**
* | output |
* | --- |
* | "Close navigation" |
*
* @param {Sidebar_Close_NavigationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_close_navigation = /** @type {((inputs?: Sidebar_Close_NavigationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Close_NavigationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_close_navigation(inputs)
	return es_sidebar_close_navigation(inputs)
});